export const SHOPPING_CART = (numberOfItems: number) => `Handlekurv (${numberOfItems})`;
export const SHOPPING_CART_RECEIPT = "Din bestilling";
